import {
  faBox,
  faFileAlt,
  faGavel,
  faGlobe,
  faHome,
  faSearch,
  faSign,
  faStopwatch,
} from '@fortawesome/pro-light-svg-icons'

const generateNavigationItems = (agencyIdParam: number | 'all') => (
  {
    sections: [
      {
        key: 'overviews',
        title: 'OVERVIEWS',
        visible: true,
        items: [
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/auctions`,
            icon: faGavel,
            key: 'overview-auctions',
            title: 'Auctions',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/campaigns`,
            icon: faHome,
            key: 'overview-campaigns',
            title: 'Campaigns',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/deadlines`,
            icon: faStopwatch,
            key: 'overview-deadlines',
            title: 'Deadlines',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/inspections`,
            icon: faSearch,
            key: 'overview-inspections',
            title: 'Inspections',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/orders`,
            icon: faBox,
            key: 'overview-orders',
            title: 'Orders',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/portalSyncs`,
            icon: faGlobe,
            key: 'overview-portal-syncs',
            title: 'Portal Syncs',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/quotes`,
            icon: faFileAlt,
            key: 'overview-quotes',
            title: 'Quotes',
            visible: true,
          },
          {
            href: `#/agency/dashboard/agencies/${agencyIdParam}/overview/signboards`,
            icon: faSign,
            key: 'overview-signboards',
            title: 'Signboards',
            visible: true,
          },
        ],
      },
    ],
  })

export default generateNavigationItems
